const encryptor = require('simple-encryptor')('iloveFairplay247club')

export default encryptor
